// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3FIhA","right":"styles_right__R90jV"};